import { render, staticRenderFns } from "./DateFormatItem.vue?vue&type=template&id=1227882a"
import script from "./DateFormatItem.vue?vue&type=script&lang=js"
export * from "./DateFormatItem.vue?vue&type=script&lang=js"
import style0 from "./DateFormatItem.vue?vue&type=style&index=0&id=1227882a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports